import { useParams } from "react-router-dom";

import { LoadingPage } from "@/components/elements/Loading/Loading";
import { ProductEditPage } from "@/features/organization/product/pages/ProductEdit";
import { useProductDetail } from "@/api/services/main/organization/product";

export const ProductEdit = () => {
  const { productId } = useParams<{ productId: string }>();
  const id = Number(productId);
  const { product, isLoading } = useProductDetail(Number.isNaN(id) ? undefined : id);

  if (isLoading) return <LoadingPage />;
  if (!product) return null;

  return <ProductEditPage product={product} />;
};
